module.exports = __webpack_public_path__ + "static/media/gt.c15face7.png";